import React from "react";
import "./spacer.scss";

export default function Spacer({ w = 0, h = 0 }) {
  return <div className="spacer" style={{ width: w, height: h }}></div>;
}
